import { render, staticRenderFns } from "./AddMedicalIncident.vue?vue&type=template&id=91abec5c&scoped=true&"
import script from "./AddMedicalIncident.vue?vue&type=script&lang=js&"
export * from "./AddMedicalIncident.vue?vue&type=script&lang=js&"
import style0 from "./AddMedicalIncident.vue?vue&type=style&index=0&id=91abec5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91abec5c",
  null
  
)

export default component.exports